<template>
    <div>
        <p class="border-t border-grey-200 pt-10"> 
            <template v-if="language === Language.NL">
                Klik op onderstaande knop en wij informeren u 
                wanneer deze integratie beschikbaar is. Zo kan u ze gratis als één van de eersten uitproberen.
            </template>    
             <template v-else-if="language === Language.FR">
                Cliquez sur le bouton ci-dessous et nous vous informerons lorsque cette intégration sera disponible. 
                De cette façon, vous pouvez être l'un des premiers à essayer cette intégration gratuitement.
            </template> 
             <template v-else-if="language === Language.EN"> 
                Click the button below and we will inform you when this integration is available. 
                This way you can be one of the first to try this integration out for free.
            </template> 
        </p>

        <form v-on-valid-form="keepMeInformed" v-if="!isSent" class="relative">
            <div class="grid grid-cols-3 mobile:grid-cols-1 gap-5 mt-4">
                <div v-if="!isLoggedInWithEmail">
                    <label for="email">{{translate('email')}}*</label>
                    <input id="email"  type="email" v-model="email" v-validate.email="translate('email')" />
                </div>
                <div v-if="!isLoggedInWithEmail">
                    <label for="phone">{{translate('phone')}}</label>
                    <input id="phone" type="phone" v-model="phone" />
                </div>
                <div>
                    <label>&nbsp;</label>
                    <button type="submit" class="btn btn-primary block"><i class="fas fa-bell mr-1"></i> {{translate('keep_me_informed_btn')}}</button>
                </div>
            </div>
            <input type="text" class="absolute invisible -z-10" v-model="honey" />
        </form>

        <div v-else>
            <p>
                <b>{{translate('thank_you')}}</b> 
            </p>
        </div>
    </div>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import { SoftwarePartner } from '../../../types/dto/SoftwarePartner';
    import Ajax from '../../../lib/Ajax';
    import { Language } from '../../../types/dto/Language';
    
    export default defineComponent({
        name: 'integration_coming_soon',
        props: {
            isLoggedInWithEmail: Boolean,
            integration: Object as  () => SoftwarePartner,
            language: String as () => Language
        },
        data() {
            return {
                email: '',
                phone: '',
                isSent: false,
                Language,
                honey: ''
            }
        },
        methods: {
            async keepMeInformed(): Promise<void> {
                if (!!this.honey)
                    return;

                if(this.isLoggedInWithEmail) {
                    await Ajax.postAsync("/ajax/integrations/keep-me-informed/user", {
                        softwareId: this.integration.id
                    });

                    this.isSent = true;
                } else {
                    await Ajax.postAsync("/ajax/integrations/keep-me-informed/visitor", {
                        softwareId: this.integration.id,
                        email: this.email,
                        phone: this.phone
                    });

                    this.isSent = true;
                }
            }
        }
    })
</script>